import * as StyledShared from '../../styles';

export const AuthButtonsDefaultLayoutSkeleton = () => {
  return <StyledShared.AuthButtonSkeleton active />;
};
